import React from 'react';
import { isSearchResultAtlasGoalPartial, isSearchResultAtlasProjectPartial } from '@atlassian/search-client';
import { transformAriToId } from '@atlassian/search-common';
import Image from '@atlaskit/image';
import { capitalizeFirstLetter } from './quick-find-meta';
var getIcon = function getIcon(result) {
  return result !== null && result !== void 0 && result.iconUrl ? /*#__PURE__*/React.createElement(Image, {
    height: 24,
    width: 24,
    title: result.type,
    src: result.iconUrl
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
var getKey = function getKey(item) {
  if (isSearchResultAtlasProjectPartial(item)) {
    var _item$project;
    return (_item$project = item.project) === null || _item$project === void 0 ? void 0 : _item$project.key;
  } else if (isSearchResultAtlasGoalPartial(item)) {
    var _item$goal;
    return (_item$goal = item.goal) === null || _item$goal === void 0 ? void 0 : _item$goal.key;
  } else {
    return null;
  }
};
var getTitle = function getTitle(item) {
  if (!item) {
    return '';
  }
  var entityKey = getKey(item);
  if (entityKey) {
    return "".concat(entityKey, ": ").concat(item.title || '');
  }
  return item.title || '';
};
export var quickFindAtlasContentMapper = function quickFindAtlasContentMapper(_ref) {
  var item = _ref.node;
  return {
    id: transformAriToId((item === null || item === void 0 ? void 0 : item.id) || '', (item === null || item === void 0 ? void 0 : item.type) || ''),
    title: getTitle(item),
    url: (item === null || item === void 0 ? void 0 : item.url) || '',
    meta: capitalizeFirstLetter((item === null || item === void 0 ? void 0 : item.type) || ''),
    additionalMeta: '',
    containerId: '',
    type: "atlas ".concat(item === null || item === void 0 ? void 0 : item.type) || '',
    icon: getIcon(item)
  };
};